import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ExportHistoryRoutingModule } from './export-history-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ExportHistoryRoutingModule
  ]
})
export class ExportHistoryModule { }
